import React from 'react';
import { Col, Container, Row, Form, Button } from 'react-bootstrap';
import {AiOutlineSearch} from 'react-icons/ai';

import './help_styles/helphead.css';

export default function HelpHead() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
            <Col lg={8} className='mx-auto'>
              <div className="help_heading d-flex flex-column align-items-center">
                <h2>HELP CENTER</h2>
                <p>Ask anything about Blockchain, Web3 and Cryptocurrency</p>
              </div>
              <div className="help_head_srch">
                <Form>
                <Button className='help_search_btn'>
                  <AiOutlineSearch className='help_search_icon' />
                </Button>
                <Form.Control
                  type="search"
                  className="me-2"
                  aria-label="Search"
                 />
                </Form>
              </div>
            </Col>
        </Row>
      </Container>
    </>
  )
}
